import { ACTION_TYPES } from "./constants";

export const setActivePlanet = (number) => {
  return {
    type: ACTION_TYPES.SET_ACTIVE_PLANET,
    activePlanet: number,
  };
};
